import Reveal from './Reveal';

export default function SoundGallerySection() {
  const soundSamples = [
    {
      title: '効果音（SE）',
      description: '映像に合わせた効果音制作のサンプル',
      icon: 'ri-sound-module-line',
      category: 'SE'
    },
    {
      title: '環境音（Ambience）',
      description: '空間の雰囲気を演出する環境音',
      icon: 'ri-landscape-line',
      category: 'Ambience'
    },
    {
      title: 'ナレーション編集例',
      description: 'AIナレーションの編集・調整サンプル',
      icon: 'ri-mic-2-line',
      category: 'Narration'
    },
    {
      title: 'MA仕上げ音源',
      description: '映像作品のMA作業完成サンプル',
      icon: 'ri-film-line',
      category: 'MA'
    }
  ];

  return (
    <section id="sound-gallery" className="py-24 md:py-32 bg-site-dark">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <Reveal>
          <div className="text-center mb-20">
            <p className="eyebrow text-teal-400 text-sm md:text-base mb-4">Sound Gallery</p>
            <h2 className="text-3xl md:text-5xl font-mincho text-white mb-6">音のサンプル</h2>
            <div className="w-20 h-[3px] bg-teal-400 mx-auto mb-6 rounded-full"></div>
            <p className="text-xl text-zinc-400">
              音の表情や空気感を感じてください。
            </p>
          </div>
          </Reveal>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {soundSamples.map((sample, index) => (
              <Reveal key={index} variant="fly" direction="up" delay={(index % 4) * 90}>
              <div className="bg-white/[0.03] border border-white/10 rounded-xl p-6 hover:border-teal-400/40 transition-all group cursor-pointer">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-500/10 rounded-lg mb-4 group-hover:bg-teal-500 transition-colors mx-auto">
                  <i className={`${sample.icon} text-2xl text-teal-300 group-hover:text-white transition-colors`}></i>
                </div>
                <h3 className="text-lg font-medium text-white mb-2 text-center">{sample.title}</h3>
                <p className="text-zinc-400 text-sm text-center mb-4">{sample.description}</p>
                <div className="flex items-center justify-center">
                  {sample.category === 'MA' ? (
                    <div className="flex flex-col gap-2 w-full">
                      <button
                        className="flex items-center justify-center text-teal-300 hover:text-teal-200 transition-colors cursor-pointer whitespace-nowrap"
                        onClick={() => window.open('https://youtu.be/KSYImhiDXAk', '_blank')}
                      >
                        <i className="ri-play-circle-line mr-2"></i>
                        試聴１
                      </button>
                      <button
                        className="flex items-center justify-center text-teal-300 hover:text-teal-200 transition-colors cursor-pointer whitespace-nowrap"
                        onClick={() => window.open('https://youtu.be/UxjgVt0qoes', '_blank')}
                      >
                        <i className="ri-play-circle-line mr-2"></i>
                        試聴２
                      </button>
                    </div>
                  ) : sample.category === 'Ambience' ? (
                    <button
                      className="flex items-center text-teal-300 hover:text-teal-200 transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => window.open('https://youtu.be/XDyBrhiAepM', '_blank')}
                    >
                      <i className="ri-play-circle-line mr-2"></i>
                      環境音
                    </button>
                  ) : sample.category === 'Narration' ? (
                    <button
                      className="flex items-center text-teal-300 hover:text-teal-200 transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => window.open('https://youtu.be/yDzv9ZVi2XQ', '_blank')}
                    >
                      <i className="ri-play-circle-line mr-2"></i>
                      AIナレーション
                    </button>
                  ) : (
                    <button
                      className="flex items-center text-teal-300 hover:text-teal-200 transition-colors cursor-pointer whitespace-nowrap"
                      onClick={() => window.open('https://youtu.be/I4mzWy28nx8', '_blank')}
                    >
                      <i className="ri-play-circle-line mr-2"></i>
                      効果音（SE）
                    </button>
                  )}
                </div>
              </div>
              </Reveal>
            ))}
          </div>

          {/* AI事業セクション */}
          <div className="mb-12">
            <div className="text-center mb-8">
              <p className="eyebrow text-teal-400 text-sm mb-2">AI Service</p>
              <h3 className="text-3xl font-mincho text-white mb-4">AI事業</h3>
              <div className="w-16 h-[3px] bg-teal-400 mx-auto mb-4 rounded-full"></div>
              <p className="text-lg text-zinc-400">
                最新のAI技術を活用した音響制作サービス
              </p>
            </div>

            <div className="flex justify-center">
              <div className="bg-white/[0.03] border border-white/10 rounded-xl p-8 hover:border-teal-400/40 transition-all max-w-md w-full">
                <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-700 rounded-lg mb-6 mx-auto">
                  <i className="ri-robot-line text-3xl text-white"></i>
                </div>
                <h4 className="text-xl font-medium text-white mb-3 text-center">AI音響制作サンプル</h4>
                <p className="text-zinc-400 text-center mb-6">
                  AIを活用した最新の音響制作技術のデモンストレーション
                </p>
                <div className="text-center">
                  <button
                    className="inline-flex items-center justify-center bg-teal-500 text-white px-6 py-3 rounded-lg hover:bg-teal-400 transition-colors cursor-pointer whitespace-nowrap font-medium"
                    onClick={() => window.open('https://youtu.be/gCN3sd-glq8', '_blank')}
                  >
                    <i className="ri-play-circle-fill mr-2 text-xl"></i>
                    AI制作サンプル視聴
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-yellow-500/5 border border-yellow-500/20 rounded-lg p-6 text-center">
            <i className="ri-information-line text-yellow-400 text-2xl mb-3"></i>
            <p className="text-zinc-300">
              ※著作権の関係上、掲載可能な範囲でデモを公開しています。<br />
              詳細なサンプルについては、お問い合わせください。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}